export default __webpack_public_path__ + "static/fili-draggable-ed3ed5b886351c6abfa527feb842dc00.png";